"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const _1 = require(".");
class WithLoadingSpinner extends React.Component {
    render() {
        if (this.props.data && !this.props.data.loading) {
            const renderFunction = this.props.children;
            return renderFunction(this.props.data);
        }
        else {
            return React.createElement(_1.Spinner, null);
        }
    }
}
exports.WithLoadingSpinner = WithLoadingSpinner;
exports.withLoadingSpinner = (Component) => class WithLoadingSpinner extends React.Component {
    render() {
        if (this.props.data && this.props.data.networkStatus != 1) {
            // not initial load
            return React.createElement(Component, Object.assign({}, this.props));
        }
        else {
            return React.createElement(_1.Spinner, null);
        }
    }
};
